// extracted by mini-css-extract-plugin
export default {"refundsBody":"RefundsPage_refundsBody__lta-0"};